import BlockCard from "../workdoc/BlockCard";
import { useWorkDocumentDetail } from "@/lib/workDocumentQueries";
import { useBlockPresence } from "@/hooks/useBlockPresence";

/**
 * Master v5 Prompt 9 — "Room runtime must support WorkDocuments as well
 * as InteractionInstances" (locked rule). Reuses BlockCard (the accepted
 * Prompt 8A engine) completely unchanged — the Room simply mounts it
 * inside the focused Room chrome instead of WorkDocumentDetail's ordinary
 * shell page.
 */
export default function WorkDocumentRoomView({ workspaceId, docId, isViewAsClient }) {
  const { data, isPending, isError } = useWorkDocumentDetail(workspaceId, docId);
  useBlockPresence({ workspaceId, docId, enabled: !!data && !isError });

  if (isError) {
    return <p className="text-terracotta text-sm" data-testid="room-work-document-error">This document could not be loaded.</p>;
  }
  if (isPending || !data) {
    return <p className="text-ink-soft text-sm" data-testid="room-work-document-loading">Loading…</p>;
  }

  const document_ = data.document;
  const isSubmitted = document_.status === "submitted";
  const blocks = data.blocks || [];

  return (
    <div data-testid="renderer-interactive-worksheet">
      <p className="text-xs text-ink-soft mb-4 capitalize">{document_.visibility_scope.replace("_", " ")} · {document_.status}</p>
      <div className="space-y-3" data-testid="room-work-document-blocks">
        {blocks.map((b) => (
          <BlockCard key={b.block_id} workspaceId={workspaceId} docId={docId} block={b} isViewAsClient={isViewAsClient} isDocumentSubmitted={isSubmitted} />
        ))}
        {blocks.length === 0 && <p className="text-ink-soft text-sm" data-testid="room-work-document-blocks-empty">No sections yet.</p>}
      </div>
    </div>
  );
}
